import { useNavigate }
from "react-router-dom";
import React, {
	useEffect,
	useState
} from "react";
import calcularMapaComponente
from "../funciones/calcularMapaComponente";

import {
	useParams
} from "react-router-dom";

import styled from "styled-components";

import {
	useAuth
} from "../contextos/AuthContext";

import calcularComponentesExamen
from "../funciones/calcularComponentesExamen";

import generarPlanEstudio
from "../funciones/generarPlanEstudio";

import generarPdfPlan
from "../funciones/generarPdfPlan";

import {
	collection,
	getDocs
}
from "firebase/firestore";

import {
	db
}
from "../firebase/firebaseConfig";


const PortalMeta = () => {

    console.log("PORTAL META CARGADO");

	const { codigo } = useParams();

	const { usuario } = useAuth();

	const navigate =
	useNavigate();

	const [data, setData] =
		useState(null);

		const descargarPlan =
			async () => {
		
				const examenPorCodigo = {

					icfes: 1,
				
					unal: 2,
				
					udea: 3
				};
				
				const plan =
					await generarPlanEstudio({
				
						usuario,
				
						examenId:
							examenPorCodigo[
								codigo
							],
				
						examen:
							data.examen,
				
						componentes:
							data.componentes
					});

					console.log(
						"PLAN PDF:",
						plan
					);
					
					generarPdfPlan(
						plan
					);

					

		};	

	useEffect(() => {

		const cargar =
			async () => {

			if (!usuario) return;

            const mapa =
                await calcularMapaComponente(
                    usuario.uid,
                    1
                );

				console.table(
					mapa.map(t => ({
						id: t.id,
						nombre: t.nombre,
						nivel: t.nivel,
						estado: t.estado
					}))
				);

            console.log("USUARIO:", usuario);
            console.log("CODIGO:", codigo);

			const resultado =
				await calcularComponentesExamen(
					usuario.uid
				);

				const simulacrosSnap =
				await getDocs(
					collection(
						db,
						"simulacros_componentes"
					)
				);
			
			const simulacros =
				simulacrosSnap.docs.map(
					d => d.data()
				);	

            console.log(
                    "RESULTADO COMPONENTES:",
                    resultado
                );    

			const examenPorCodigo = {

				icfes: 1,

				unal: 2,

				udea: 3
			};

            console.log(
                "EXAMEN SELECCIONADO:",
                resultado[
                    examenPorCodigo[codigo]
                ]
            );

			const examenActual =
	resultado[
		examenPorCodigo[
			codigo
		]
	];

Object.values(
	examenActual.componentes
).forEach(comp => {

	const existe =
	simulacros.find(
		s =>
			s.userId === usuario.uid &&
			s.examen === codigo &&
			Number(
				s.componente
			) === Number(
				comp.id
			)
	);

	console.log(
		"SIMULACRO BUSCADO",
		comp.id,
		existe
	);

	comp.simulacroCompletado =
		!!existe;
});

setData(
	examenActual
);
		};

		cargar();

	}, [
		usuario,
		codigo
	]);

	if (!data) {

		return (
			<Contenedor>
				Cargando portal...
			</Contenedor>
		);
	}

	console.log(
		"COMPONENTES PORTAL:",
		data.componentes
	);

	const componentes =
		Object.values(
			data.componentes
		);

		const misionActual =
		componentes
			.filter(
				c =>
					c.simulacroCompletado
			)
			.sort(
				(a, b) =>
					(a.energia || 0)
					-
					(b.energia || 0)
			)[0];	

			const misionDiaria = {

				titulo:
					"⚔️ Entrenamiento diario",
			
				texto:
					"Completa una batalla para mantener tu conocimiento activo",
			
				recompensa:
					"+100 XP 🔥"
			};	

		const regionesPendientes =
		componentes.filter(
			c => !c.simulacroCompletado
		);
	
	const siguienteRegion =
		regionesPendientes[0];	

	const temasDescubiertos =
		componentes.reduce(
			(acc, c) =>
				acc +
				(c.temasExplorados || 0),
			0
		);

	const temasDominados =
		componentes.reduce(
			(acc, c) =>
				acc +
				(c.temasEvaluados || 0),
			0
		);

	const totalRegiones =
		componentes.length;

	const progresoGlobal =
		Math.min(
			100,
			Math.round(
				(
					temasDescubiertos /
					Math.max(
						totalRegiones * 10,
						1
					)
				) * 100
			)
		);

	let nivelExplorador = 1;

	if (
		temasDescubiertos >= 10
	) {
		nivelExplorador = 2;
	}

	if (
		temasDescubiertos >= 25
	) {
		nivelExplorador = 3;
	}

	if (
		temasDescubiertos >= 50
	) {
		nivelExplorador = 4;
	}

	let rango =
		"🌱 Novato";

	if (
		nivelExplorador >= 2
	) {
		rango =
			"📡 Explorador";
	}

	if (
		nivelExplorador >= 3
	) {
		rango =
			"🔥 Conquistador";
	}

	if (
		nivelExplorador >= 4
	) {
		rango =
			"👑 Maestro";
	}
	return (

		<Contenedor>

			<Titulo>
				🌌 {data.examen}
			</Titulo>

			<Subtitulo>

				Explora las regiones
				descubiertas por Yuta

			</Subtitulo>

			<div
	style={{

		background:
			"rgba(250,204,21,.12)",

		border:
			"1px solid rgba(250,204,21,.35)",

		padding:
			"1rem",

		borderRadius:
			"16px",

		marginBottom:
			"2rem",

		maxWidth:
			"800px"
	}}
>

	<h3>

		🚀 Cómo avanzar

	</h3>

	<p>

		1️⃣ Completa el simulacro de una región.

	</p>

	<p>

		2️⃣ Desbloquea los temas de esa región.

	</p>

	<p>

		3️⃣ Entrena los temas recomendados.

	</p>

	<p>

		4️⃣ Construye tu plan de estudio personalizado.

	</p>

</div>

<BotonPdf
	onClick={async () => {

		const tieneSimulacro =
	
			Object.values(
				data.componentes
			).some(
				c =>
					c.simulacroCompletado
			);
	
		if (
			!tieneSimulacro
		) {
	
			alert(
				"🚀 Completa primero los simulacros diagnósticos para generar una ruta personalizada."
			);
	
			return;
		}
	
		const examenPorCodigo = {
	
			icfes: 1,
	
			unal: 2,
	
			udea: 3
		};
	
		const plan =
			await generarPlanEstudio({
	
				usuario,
	
				examenId:
					examenPorCodigo[
						codigo
					],
	
				examen:
					data.examen,
	
				componentes:
					data.componentes
			});
	
		console.log(
			"PLAN PDF:",
			plan
		);
	
		generarPdfPlan(
			plan
		);
	}}
>

{
	Object.values(
		data.componentes
	).some(
		c =>
			c.simulacroCompletado
	)

		? "📄 Descargar Plan"

		: "🔒 Plan de Estudio (Bloqueado)"
}

</BotonPdf>

<RPGPanel>

<h2>
	🎯 Misión Principal
</h2>



<p>

	Tu objetivo es desbloquear y dominar
	todas las regiones de {data.examen}.

</p>

<div
	style={{
		marginTop: "1rem",
		fontWeight: "bold"
	}}
>

	🧭 Nivel Explorador {nivelExplorador}

</div>

<div>
	{rango}
</div>

<Barra>

	<BarraFill
		valor={progresoGlobal}
	/>

</Barra>

<div>
	🌱 {temasDescubiertos} temas descubiertos
</div>

<div>
	⚔️ {temasDominados} temas dominados
</div>

</RPGPanel>

<QuestPanel>

    <h2>🏅 Logros</h2>

    <p>
        {temasDescubiertos >= 1
            ? "✅ Primer tema descubierto"
            : "⬜ Primer tema descubierto"}
    </p>

    <p>
        {temasDescubiertos >= 10
            ? "✅ Explorador"
            : "⬜ Explorador"}
    </p>

    <p>
        {temasDominados >= 5
            ? "✅ Estratega"
            : "⬜ Estratega"}
    </p>

    <p>
        {temasDominados >= 20
            ? "✅ Maestro"
            : "⬜ Maestro"}
    </p>

</QuestPanel>

<h2
	style={{
		marginTop: "2rem",
		marginBottom: "1.5rem",
		textAlign: "center"
	}}
>

⚔️ Regiones de Entrenamiento

</h2>

<RutaRegiones>
			<Mapa>

				{
					Object.entries(
						data.componentes
					)
					.map(
						(
							[
								nombre,
								info
							],
							index
							) => {
							
							console.log(
								"INFO REGION:",
								info
							);

							const desbloqueado =
	info.simulacroCompletado === true;

	const regionConquistada =
	info.temasEvaluados >=
	Math.max(
		3,
		Math.floor(
			info.temasExplorados * 0.7
		)
	);

	const maestria =
	Math.round(
		(
			info.temasEvaluados /
			Math.max(
				info.temasExplorados,
				1
			)
		) * 100
	);

							return (
								<div
	key={nombre}
	style={{
		display: "flex",
		flexDirection: "column",
		alignItems: "center"
	}}
>
					
					<RegionCard

onClick={() => {

	if (!desbloqueado) {

		navigate(
			`/quiz/simulacro?componente=${info.id}&examen=${codigo}`
		);
	
		return;
	}

	navigate(
		`/meta/${codigo}/componente/${info.id}`
	);
}}

					>
					
					<Estado>

{
	!desbloqueado

		? "🔒"

		: regionConquistada

		? "👑"

		:

	info.estado ===
	"sin_datos"

		? "📡"

		: info.estado ===
		"dominado"

		? "🔥"

		: info.estado ===
		"inestable"

		? "⚠️"

		: "⚔️"
}

</Estado>
					
									<h3>
										{nombre}
									</h3>

									<p>

{
	!desbloqueado
		? "Completa diagnóstico 🧪"
		: regionConquistada
		? "Reino conquistado 👑"
		: "Batalla en progreso ⚔️"
}

</p>

									{
	info.simulacroCompletado
	&& (
		<p>
			✅ Diagnóstico completado
		</p>
	)
}

									<div
    style={{
        opacity: .7,
        fontSize: ".8rem",
        marginBottom: ".5rem"
    }}
>

    Región {info.id}

</div>

									{
    info.temasEvaluados >=
    info.temasExplorados &&
    info.temasExplorados > 0 && (

        <div
            style={{
                color: "#facc15",
                fontWeight: "bold",
                marginBottom: ".5rem"
            }}
        >

🏆 REINO CONQUISTADO

        </div>
    )
}

									
					
									<p>

    🌱 Descubiertos:

    {" "}

    {info.temasExplorados}

</p>
					
<p>

⚔ Entrenados:

{" "}

{info.temasEvaluados}

</p>

<p>

⚔️ Poder del Reino: {maestria}%

</p>

<p>

🎯 Misión:

{" "}

{
	!desbloqueado
		? "Completar diagnóstico"
		: "Continuar entrenamiento"
}

</p>



							<button

style={{

	marginTop: "1rem",

	background:
		desbloqueado
			? "#22c55e"
			: "#facc15",

	color: "#111",

	border: "none",

	borderRadius: "12px",

	padding: ".6rem 1rem",

	fontWeight: "bold",

	cursor: "pointer"
}}

onClick={(e) => {

	e.stopPropagation();

	navigate(
		`/quiz/simulacro?componente=${info.id}&examen=${codigo}`
	);
}}
>

{
	desbloqueado
		? "🔄 Repetir Simulacro"
		: "⚔️ Desafiar Región"
}

</button>

{
    desbloqueado && (

        <button

            style={{

                marginTop: "1rem",

                background: "#22c55e",

                color: "#111",

                border: "none",

                borderRadius: "12px",

                padding: ".6rem 1rem",

                fontWeight: "bold",

                cursor: "pointer"
            }}

            onClick={(e) => {

                e.stopPropagation();

                navigate(
                    `/meta/${codigo}/componente/${info.id}`
                );
            }}
        >

            🎯 Continuar misión

			<div
    style={{
        marginTop: ".5rem",
        fontSize: ".8rem",
        opacity: .8
    }}
>

    Siguiente objetivo:
    dominar más temas

</div>

        </button>
    )
}					
</RegionCard>

{
	index <
	Object.entries(
		data.componentes
	).length - 1 && (

		<Conexion>

⚔️

</Conexion>
	)
}

</div>
						); })}
			</Mapa>
			</RutaRegiones>

		</Contenedor>
	);
};

export default PortalMeta;

const Contenedor =
	styled.div`

	padding: 2rem;

	color: white;
`;

const Titulo =
	styled.h1`

	font-size: 2rem;
`;

const Subtitulo =
	styled.p`

	opacity: .8;

	margin-bottom: 2rem;
`;

const RPGPanel =
styled.div`

	margin-bottom: 2rem;

	padding: 1rem;

	border-radius: 18px;

	background:
		rgba(
			255,
			255,
			255,
			0.06
		);

	border:
		1px solid rgba(
			255,
			255,
			255,
			0.12
		);

	max-width: 500px;
`;

const Barra =
styled.div`

	height: 16px;

	margin: 1rem 0;

	border-radius: 999px;

	overflow: hidden;

	background:
		rgba(
			255,
			255,
			255,
			0.12
		);
`;

const BarraFill =
styled.div`

	height: 100%;

	width:
		${props =>
			props.valor}%;
	
	background:
		linear-gradient(
			90deg,
			#00F2FF,
			#00FF95
		);

	transition:
		.4s ease;
`;

const RegionCard =
styled.div`

	width: min(
		420px,
		90vw
	);

	display: flex;

	flex-direction: column;

	align-items: center;

	padding: 1.25rem;

	border-radius: 20px;

	background:
		rgba(
			255,
			255,
			255,
			0.08
		);

	backdrop-filter:
		blur(10px);

	border:
		1px solid rgba(
			255,
			255,
			255,
			0.15
		);

	text-align: center;

	transition:
		.25s ease;

	cursor:
		pointer;

	&:hover {

		transform:
			scale(1.02);

		box-shadow:
			0 0 25px
			rgba(
				0,
				242,
				255,
				0.25
			);
	}
`;

const Estado =
	styled.div`

	font-size: 2rem;

	margin-bottom: .5rem;
`;

const Mapa =
styled.div`

	display: flex;

	flex-direction: column;

	align-items: center;

	gap: 0;
`;





const RutaRegiones =
styled.div`

	display: flex;

	flex-direction: column;

	align-items: center;

	gap: 0;

	max-width: 800px;

	margin: auto;
`;

const Conexion =
styled.div`

font-size: 2.5rem;

opacity: .6;

	margin: 1rem 0;

	color: #00F2FF;
`;




const BotonPdf =
styled.button`

	padding: .8rem 1.2rem;

	border: none;

	border-radius: 12px;

	cursor: pointer;

	margin-bottom: 2rem;

	font-weight: bold;
`;

const QuestPanel = styled.div`

    margin-bottom: 2rem;

    padding: 1rem;

    border-radius: 18px;

    background: rgba(255,255,255,.05);

    border: 1px solid rgba(255,255,255,.1);

    max-width: 500px;
`;

